/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PortalData
 */
export interface PortalData {
    /**
     * 
     * @type {string}
     * @memberof PortalData
     */
    tenant_id?: string;
    /**
     * 
     * @type {string}
     * @memberof PortalData
     */
    staff_title?: string;
    /**
     * 
     * @type {string}
     * @memberof PortalData
     */
    small_logo_color_url?: string;
    /**
     * 
     * @type {string}
     * @memberof PortalData
     */
    full_logo_color_url?: string;
    /**
     * 
     * @type {string}
     * @memberof PortalData
     */
    icon_color_url?: string;
    /**
     * 
     * @type {string}
     * @memberof PortalData
     */
    favicon?: string;
    /**
     * 
     * @type {string}
     * @memberof PortalData
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof PortalData
     */
    name_short?: string;
    /**
     * 
     * @type {string}
     * @memberof PortalData
     */
    support_email?: string;
    /**
     * 
     * @type {string}
     * @memberof PortalData
     */
    company_website?: string;
    /**
     * Tenant IANA timezone — clients format tenant-local dates/times with this instead of a hardcoded zone.
     * @type {string}
     * @memberof PortalData
     */
    timezone?: string;
    /**
     * Tenant jurisdiction province — clients use this as the default for province fields instead of a hardcoded value.
     * @type {string}
     * @memberof PortalData
     */
    province?: string;
}

/**
 * Check if a given object implements the PortalData interface.
 */
export function instanceOfPortalData(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PortalDataFromJSON(json: any): PortalData {
    return PortalDataFromJSONTyped(json, false);
}

export function PortalDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortalData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'tenant_id': !exists(json, 'tenant_id') ? undefined : json['tenant_id'],
        'staff_title': !exists(json, 'staff_title') ? undefined : json['staff_title'],
        'small_logo_color_url': !exists(json, 'small_logo_color_url') ? undefined : json['small_logo_color_url'],
        'full_logo_color_url': !exists(json, 'full_logo_color_url') ? undefined : json['full_logo_color_url'],
        'icon_color_url': !exists(json, 'icon_color_url') ? undefined : json['icon_color_url'],
        'favicon': !exists(json, 'favicon') ? undefined : json['favicon'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'name_short': !exists(json, 'name_short') ? undefined : json['name_short'],
        'support_email': !exists(json, 'support_email') ? undefined : json['support_email'],
        'company_website': !exists(json, 'company_website') ? undefined : json['company_website'],
        'timezone': !exists(json, 'timezone') ? undefined : json['timezone'],
        'province': !exists(json, 'province') ? undefined : json['province'],
    };
}

export function PortalDataToJSON(value?: PortalData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'tenant_id': value.tenant_id,
        'staff_title': value.staff_title,
        'small_logo_color_url': value.small_logo_color_url,
        'full_logo_color_url': value.full_logo_color_url,
        'icon_color_url': value.icon_color_url,
        'favicon': value.favicon,
        'name': value.name,
        'name_short': value.name_short,
        'support_email': value.support_email,
        'company_website': value.company_website,
        'timezone': value.timezone,
        'province': value.province,
    };
}

